var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLink3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0006,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13.0006C24.5523 13.0006 25 13.4483 25 14.0006V18.0006C25 18.5529 24.5523 19.0006 24 19.0006C23.4477 19.0006 23 18.5529 23 18.0006V14.0006C23 13.4483 23.4477 13.0006 24 13.0006Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 29.0006C24.5523 29.0006 25 29.4483 25 30.0006V34.0006C25 34.5529 24.5523 35.0006 24 35.0006C23.4477 35.0006 23 34.5529 23 34.0006V30.0006C23 29.4483 23.4477 29.0006 24 29.0006Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2226 16.2235C16.6131 15.833 17.2463 15.833 17.6368 16.2235L20.4668 19.0535C20.8573 19.444 20.8573 20.0772 20.4668 20.4677C20.0763 20.8582 19.4431 20.8582 19.0526 20.4677L16.2226 17.6377C15.8321 17.2472 15.8321 16.614 16.2226 16.2235Z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5331 27.5335C27.9237 27.143 28.5568 27.143 28.9473 27.5335L31.7773 30.3635C32.1679 30.754 32.1679 31.3872 31.7773 31.7777C31.3868 32.1682 30.7537 32.1682 30.3631 31.7777L27.5331 28.9477C27.1426 28.5572 27.1426 27.924 27.5331 27.5335Z",
    fill: "#FCFCFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 24.0006C13 23.4483 13.4477 23.0006 14 23.0006H18C18.5523 23.0006 19 23.4483 19 24.0006C19 24.5529 18.5523 25.0006 18 25.0006H14C13.4477 25.0006 13 24.5529 13 24.0006Z",
    fill: "#FCFCFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 24.0006C29 23.4483 29.4477 23.0006 30 23.0006H34C34.5523 23.0006 35 23.4483 35 24.0006C35 24.5529 34.5523 25.0006 34 25.0006H30C29.4477 25.0006 29 24.5529 29 24.0006Z",
    fill: "#FCFCFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4668 27.5335C20.8573 27.924 20.8573 28.5572 20.4668 28.9477L17.6368 31.7777C17.2463 32.1682 16.6131 32.1682 16.2226 31.7777C15.8321 31.3872 15.8321 30.754 16.2226 30.3635L19.0526 27.5335C19.4431 27.143 20.0763 27.143 20.4668 27.5335Z",
    fill: "#FCFCFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7773 16.2235C32.1679 16.614 32.1679 17.2472 31.7773 17.6377L28.9473 20.4677C28.5568 20.8582 27.9237 20.8582 27.5331 20.4677C27.1426 20.0772 27.1426 19.444 27.5331 19.0535L30.3631 16.2235C30.7537 15.833 31.3868 15.833 31.7773 16.2235Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink3);
export default __webpack_public_path__ + "static/media/icon-link3.287daf623d0575d09ce09b599c81dd18.svg";
export { ForwardRef as ReactComponent };